import { QUERY_KEYS } from '../../../../../consts';
import { downloadQuoteMediaService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const downloadQuoteMediaAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.QUOTES.DOWNLOAD_QUOTE_MEDIA,
  mutationFn: () => downloadQuoteMediaService,
});
